<!--
 * @Author: 'lek' '2889356275@qq.com'
 * @Date: 2025-05-13 11:39:59
 * @LastEditors: 'lek' '2889356275@qq.com'
 * @LastEditTime: 2025-06-05 15:03:36
 * @FilePath: \HTML和CSSe:\巴斯德\公司网站\bsd_website\src\views\HomePage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app">
    <CommonHeader :headerData="headerData" @nav-change="handleNavChange" />

    <!-- 首屏大图区 -->
    <section class="hero" ref="hero">
      <div class="petri-dish-layout">
        <!-- 中央大培养皿 -->
        <div class="central-dish-container">
          <div class="petri-dish central-dish">
            <div
              v-for="molecule in centralMolecules"
              :key="molecule.id"
              class="molecule"
              :class="[
                `molecule-${molecule.size}`,
                `molecule-central-${molecule.id}`
              ]"
            ></div>
          </div>
          <div class="petri-lid central-lid"></div>
        </div>
        
        <!-- 核心标语 -->
        <div class="mission-statement">
          <div class="mission-text-container">
            <h1 class="mission-text">
              <span class="text-highlight">{{ $t('home.title') }}</span>
              <span class="text-separator">•</span>
              <span class="text-normal">{{ $t('home.subtitle1') }}</span>
              <span class="text-separator">•</span>
              <span class="text-emphasis">{{ $t('home.subtitle2') }}</span>
            </h1>
            <div class="text-decoration-line"></div>
            <div class="text-glow-effect"></div>
          </div>
        </div>
      </div>
    </section>

    <CommonFooter />
    <BackToTop />
  </div>
</template>

<script>
import CommonHeader from '../components/CommonHeader.vue';
import CommonFooter from '../components/CommonFooter.vue';
import BackToTop from '../components/BackToTop.vue';

export default {
  name: 'PasteurHomepage',

  components: {
      CommonHeader,
      CommonFooter,
      BackToTop
  },

  data() {
    return {
      // 头部数据配置
      headerData: {
        logo: {
          title: 'PASTEUR',
          imageUrl: require('@/assets/image/logo.png')
        },
        navigation: [
          { key: 'welcome', active: true, hovered: false },
          { key: 'company', active: false, hovered: false },
          { key: 'products', active: false, hovered: false },
          { key: 'links', active: false, hovered: false }
        ]
      },

      // 中央大培养皿分子数据
      centralMolecules: [
        { id: 1, size: 'large' },
        { id: 2, size: 'medium' },
        { id: 3, size: 'large' },
        { id: 4, size: 'small' },
        { id: 5, size: 'medium' },
        { id: 6, size: 'small' },
        { id: 7, size: 'large' },
        { id: 8, size: 'medium' },
        { id: 9, size: 'small' },
        { id: 10, size: 'medium' },
        { id: 11, size: 'large' },
        { id: 12, size: 'small' },
        { id: 13, size: 'medium' },
        { id: 14, size: 'small' },
        { id: 15, size: 'large' }
      ],


      // 组件状态管理
      showBackToTop: false,
    }
  },

  // 生命周期钩子
  mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    async fetchHeaderData() {
      
    },

    // 处理导航变化
    handleNavChange(index) {
      const routes = ['/welcome', '/company', '/products', '/links'];
      if (index >= 0 && index < routes.length) {
        const targetRoute = routes[index];
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }
      }
    },

    // 滚动事件处理
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.showBackToTop = scrollTop > 300;
    }
  },

}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: 'Microsoft YaHei', sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
}

/* 首屏区域 */
.hero {
  position: relative;
  background:
    radial-gradient(ellipse at 30% 30%, rgba(250, 250, 250, 0.8) 0%, transparent 60%),
    radial-gradient(ellipse at 70% 70%, rgba(248, 249, 250, 0.6) 0%, transparent 60%),
    linear-gradient(135deg,
      #fafafa 0%,
      #f8f9fa 50%,
      #fafafa 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 80px;
  padding: 20px;
}

/* 培养皿布局容器 */
.petri-dish-layout {
  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 80vh;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 中央大培养皿容器 */
.central-dish-container {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

/* 核心标语容器 */
.mission-statement {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 5;
  max-width: 900px;
  padding: 0 20px;
}

/* 标题文字容器 */
.mission-text-container {
  position: relative;
  padding: 2rem 0;
}

/* 标题文字样式 */
.mission-text {
  margin: 0;
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 200;
  letter-spacing: 0.12em;
  line-height: 1.6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 0.5rem;
  animation: fadeInUp 2s ease-out forwards;
  opacity: 0;
  white-space: nowrap;
  position: relative;
  z-index: 2;
}

/* 文字片段基础样式 */
.text-highlight,
.text-normal,
.text-emphasis {
  font-size: clamp(1.2rem, 2.5vw, 1.5rem);
  position: relative;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

/* 高亮文字 */
.text-highlight {
  font-weight: 800;
  background: linear-gradient(135deg, #0cc6b0 0%, #0cc6b0 50%, #0cc6b0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 10px rgba(88, 226, 173, 0.3);
  position: relative;
}

.text-highlight::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  background: radial-gradient(circle, rgba(52, 73, 78, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.6s ease;
  z-index: -1;
}

.text-highlight:hover::before {
  opacity: 1;
}

/* 普通文字 - 食品安全部分 */
.text-normal {
  font-weight: 800;
  background: linear-gradient(135deg, #0cc6b0 0%, #0cc6b0 50%, #0cc6b0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 10px rgba(88, 226, 173, 0.3);
  position: relative;
}

.text-normal::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  background: radial-gradient(circle, rgba(52, 73, 78, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.6s ease;
  z-index: -1;
}

.text-normal:hover::before {
  opacity: 1;
}

/* 强调文字 - 生命健康部分 */
.text-emphasis {
  font-weight: 800;
  background: linear-gradient(135deg, #0cc6b0 0%, #0cc6b0 50%, #0cc6b0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 10px rgba(88, 226, 173, 0.3);
  position: relative;
}

.text-emphasis::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  background: radial-gradient(circle, rgba(26, 37, 47, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.6s ease;
  z-index: -1;
}

.text-emphasis:hover::before {
  opacity: 1;
}

/* 分隔符样式 */
.text-separator {
  font-size: clamp(1.5rem, 2.8vw, 1.4rem);
  background: linear-gradient(135deg, #4adbc5, #09aa8a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  opacity: 0.8;
  font-weight: 200;
  margin: 0 0.3rem;
  animation: separatorPulse 3s ease-in-out infinite;
  position: relative;
  display: inline-block;
  transform-origin: center;
}

/* 文字渐入上移动画 */
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(40px);
    filter: blur(4px);
  }
  50% {
    opacity: 0.7;
    transform: translateY(10px);
    filter: blur(1px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

/* 分隔符脉动动画 */
@keyframes separatorPulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1) rotate(0deg);
    filter: brightness(1);
  }
  25% {
    opacity: 0.9;
    transform: scale(1.15) rotate(5deg);
    filter: brightness(1.2);
  }
  50% {
    opacity: 1;
    transform: scale(1.2) rotate(-5deg);
    filter: brightness(1.4);
  }
  75% {
    opacity: 0.9;
    transform: scale(1.1) rotate(3deg);
    filter: brightness(1.2);
  }
}

/* 文字悬停效果 */
.text-highlight:hover {
  transform: translateY(-6px) scale(1.08) rotate(1deg);
  filter: brightness(1.1) drop-shadow(0 8px 25px rgba(52, 73, 78, 0.4));
}

.text-emphasis:hover {
  transform: translateY(-6px) scale(1.08) rotate(1deg);
  filter: brightness(1.1) drop-shadow(0 8px 25px rgba(26, 37, 47, 0.4));
}

.text-normal:hover {
  transform: translateY(-6px) scale(1.08) rotate(1deg);
  filter: brightness(1.1) drop-shadow(0 8px 25px rgba(52, 73, 78, 0.4));
}

/* 装饰线 */
.text-decoration-line {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 3px;
  background: linear-gradient(90deg,
    transparent 0%,
    #00D4B4 20%,
    #00B894 50%,
    #00D4B4 80%,
    transparent 100%);
  border-radius: 2px;
  animation: decorationLineExpand 4s ease-in-out infinite 1s;
  box-shadow: 0 0 20px rgba(0, 212, 180, 0.5);
}

@keyframes decorationLineExpand {
  0%, 100% {
    width: 0;
    opacity: 0;
  }
  20% {
    width: 150px;
    opacity: 0.8;
  }
  50% {
    width: 300px;
    opacity: 1;
  }
  80% {
    width: 200px;
    opacity: 0.6;
  }
}

/* 发光效果 */
.text-glow-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  background: radial-gradient(ellipse at center,
    rgba(0, 212, 180, 0.1) 0%,
    rgba(0, 212, 180, 0.05) 30%,
    transparent 70%);
  border-radius: 50%;
  opacity: 0;
  animation: glowPulse 4s ease-in-out infinite 2s;
  pointer-events: none;
  z-index: 1;
}

@keyframes glowPulse {
  0%, 100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }
  50% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1.2);
  }
}


/* 中央大培养皿 */
.central-dish {
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background:
    radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.3), transparent 50%),
    linear-gradient(145deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08));
  backdrop-filter: blur(10px);
  border: 8px solid rgba(0, 212, 180, 0.2);
  box-shadow:
    0 8px 32px rgba(0, 212, 180, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  animation: centralDishRotate 60s linear infinite;
  position: relative;
  overflow: hidden;
}

/* 中央培养皿内部效果 */
.central-dish::before {
  content: '';
  position: absolute;
  top: 10%;
  left: 10%;
  right: 10%;
  bottom: 10%;
  border-radius: 50%;
  background: radial-gradient(circle, transparent 30%, rgba(0, 212, 180, 0.05) 100%);
  border: 2px solid rgba(0, 212, 180, 0.1);
}

/* 中央培养皿盖子 */
.central-lid {
  position: absolute;
  top: -10px;
  left: -10px;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background:
    radial-gradient(circle at 40% 40%, rgba(255, 255, 255, 0.1), transparent 70%),
    linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
  backdrop-filter: blur(2px);
  border: 6px solid rgba(0, 212, 180, 0.15);
  box-shadow:
    0 6px 24px rgba(0, 212, 180, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  animation: centralLidOpenClose 20s ease-in-out infinite;
  transform-origin: right center;
}


/* 分子基础样式 */
.molecule {
  position: absolute;
  background: radial-gradient(circle, #00D4B4 0%, rgba(0, 184, 148, 0.8) 40%, transparent 80%);
  border-radius: 50%;
  box-shadow:
    0 0 10px rgba(0, 212, 180, 0.5),
    0 0 20px rgba(0, 212, 180, 0.15);
}

/* 中央培养皿分子 */
.molecule-large {
  width: 12px;
  height: 12px;
  animation: centralMoleculeFloat 3s ease-in-out infinite;
}

.molecule-medium {
  width: 8px;
  height: 8px;
  animation: centralMoleculeFloat 4s ease-in-out infinite;
}

.molecule-small {
  width: 6px;
  height: 6px;
  animation: centralMoleculeFloat 5s ease-in-out infinite;
}


/* 中央培养皿分子位置 */
.molecule-central-1 { top: 20%; left: 30%; animation-delay: 0s; }
.molecule-central-2 { top: 15%; left: 65%; animation-delay: 0.5s; }
.molecule-central-3 { top: 35%; left: 75%; animation-delay: 1s; }
.molecule-central-4 { top: 60%; left: 25%; animation-delay: 1.5s; }
.molecule-central-5 { top: 65%; left: 60%; animation-delay: 2s; }
.molecule-central-6 { top: 30%; left: 45%; animation-delay: 2.5s; }
.molecule-central-7 { top: 50%; left: 40%; animation-delay: 3s; }
.molecule-central-8 { top: 40%; left: 70%; animation-delay: 0.3s; }
.molecule-central-9 { top: 75%; left: 70%; animation-delay: 1.8s; }
.molecule-central-10 { top: 10%; left: 50%; animation-delay: 2.3s; }
.molecule-central-11 { top: 45%; left: 20%; animation-delay: 0.7s; }
.molecule-central-12 { top: 70%; left: 45%; animation-delay: 1.2s; }
.molecule-central-13 { top: 25%; left: 80%; animation-delay: 2.8s; }
.molecule-central-14 { top: 55%; left: 55%; animation-delay: 3.5s; }
.molecule-central-15 { top: 80%; left: 30%; animation-delay: 4.2s; }


/* 动画效果 */
@keyframes centralDishRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes centralLidOpenClose {
  0% {
    /* 盖子关闭状态 */
    transform: translateX(0) rotate(0deg);
  }
  10% {
    /* 向左边打开 (约2秒) */
    transform: translateX(-280px) rotate(-15deg);
  }
  20% {
    /* 盖回去 (约2秒) */
    transform: translateX(0) rotate(0deg);
  }
  30% {
    /* 等待2秒期间保持关闭 */
    transform: translateX(0) rotate(0deg);
  }
  85% {
    /* 向右旋转一周回来 (约11秒，包含旋转360度) */
    transform: translateX(0) rotate(360deg);
  }
  100% {
    /* 回到关闭位置，准备下一轮 */
    transform: translateX(0) rotate(360deg);
  }
}


@keyframes centralMoleculeFloat {
  0%, 100% {
    transform: translateY(0px) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-20px) scale(1.2);
    opacity: 1;
  }
}


/* 培养皿发光效果 */
.central-dish::before {
  content: '';
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 50%;
  background: linear-gradient(45deg, #00D4B4, #00B894);
  opacity: 0.15;
  z-index: -1;
  animation: dishGlow 4s ease-in-out infinite;
}


@keyframes dishGlow {
  0%, 100% {
    opacity: 0.08;
    transform: scale(1);
  }
  50% {
    opacity: 0.2;
    transform: scale(1.02);
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .petri-dish-layout {
    height: 70vh;
    min-height: 500px;
  }
  
  .central-dish-container {
    top: 30%;
  }
  
  .central-dish {
    width: 350px;
    height: 350px;
  }
  
  .central-lid {
    width: 380px;
    height: 380px;
    top: -18px;
    left: -18px;
    transform: translateX(-253px) rotate(-15deg);
  }
  
  .mission-statement {
    top: 60%;
    max-width: 600px;
  }
  
  .text-highlight,
  .text-normal,
  .text-emphasis {
    font-size: clamp(1.2rem, 2.8vw, 1.7rem);
  }
  
  .text-separator {
    font-size: clamp(1.3rem, 3.2vw, 2rem);
  }
}

@media (max-width: 768px) {
  .hero {
    margin-top: 60px;
  }
  
  .petri-dish-layout {
    height: 60vh;
    min-height: 400px;
  }
  
  .central-dish-container {
    top: 25%;
  }
  
  .central-dish {
    width: 280px;
    height: 280px;
  }
  
  .central-lid {
    width: 300px;
    height: 300px;
    top: -15px;
    left: -15px;
    transform: translateX(-200px) rotate(-15deg);
  }
  
  .mission-statement {
    top: 55%;
    max-width: 500px;
    padding: 0 15px;
  }
  
  .text-highlight,
  .text-normal,
  .text-emphasis {
    font-size: clamp(1.1rem, 2.5vw, 1.5rem);
  }
  
  .text-separator {
    font-size: clamp(1.2rem, 2.8vw, 1.7rem);
  }
  
  .mission-text {
    flex-wrap: wrap;
    gap: 0.3rem;
    white-space: normal;
  }
}

@media (max-width: 480px) {
  .hero {
    margin-top: 50px;
  }
  
  .petri-dish-layout {
    height: 50vh;
    min-height: 350px;
  }
  
  .central-dish-container {
    top: 20%;
  }
  
  .central-dish {
    width: 220px;
    height: 220px;
  }
  
  .central-lid {
    width: 240px;
    height: 240px;
    top: -12px;
    left: -12px;
    transform: translateX(-160px) rotate(-15deg);
  }
  
  .mission-statement {
    top: 50%;
    max-width: 90vw;
    padding: 0 10px;
  }
  
  .mission-text {
    line-height: 1.5;
  }
  
  .text-highlight,
  .text-normal,
  .text-emphasis {
    font-size: clamp(1rem, 3.2vw, 1.3rem);
  }
  
  .text-separator {
    font-size: clamp(1.1rem, 3.8vw, 1.5rem);
  }
  
  .mission-text {
    flex-wrap: wrap;
    gap: 0.2rem;
    line-height: 1.4;
    white-space: normal;
  }
}
</style>